<!-- content -->
@switch (storageData.step < 0) {
  @case (true) {
    <div
      class="_loader pos-relative bg-col-4 _max-height w-12"><i
    class="icon-loading inline-flex pos-absolute top-50 left-50"></i></div>
  }
  @case (false) {
    @switch (storageData.step === ESteps.products) {
      @case (false) {
        <outfit-general-setup
          class="block _max-height"
          [content]="typeData"
        [storageData]="storageData"></outfit-general-setup>
      }
      @case (true) {
        @switch (isLoaded) {
          @case (true) {
            <outfit-products-setup
              [content]="typeData"
            [storageData]="storageData"></outfit-products-setup>
          }
          @case (false) {
            <div
              class="_loader pos-relative bg-col-4 _max-height w-12"><i
            class="icon-loading inline-flex pos-absolute top-50 left-50"></i></div>
          }
        }
      }
    }
  }
}
